import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';
import classNames from 'classnames';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.FirstName.placeholder',
        defaultMessage: 'First Name*',
    },
});

const FirstName = ({
    value,
    autoFocus = false,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
    isMobile,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="firstName"
            dataTn="first-name"
            value={value}
            wrapperClass={classNames(isMobile ? styles.group : styles.left)}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="given-name"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

FirstName.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    isMobile: PropTypes.bool,
};

export default FirstName;
